export default "__VITE_ASSET__fa03febc__"